import React from 'react';
import { BookOpenIcon, FilterIcon, CalculatorIcon, ShieldIcon, CheckSquareIcon, CheckIcon, LanguagesIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-6 h-6 text-brand-gold" data-id="element-241" />,
    title: 'El Método Anti-Tipster (PDF)',
    description: 'Valor: $97\nConstruye un criterio que te permita detectar apuestas con ventaja…'
  }, {
    icon: <FilterIcon className="w-6 h-6 text-brand-gold" data-id="element-242" />,
    title: 'El Protocolo de Confirmación de 5 Pasos',
    description: 'Valor: $147\nEl filtro exacto que evita apuestas impulsivas…'
  }, {
    icon: <CalculatorIcon className="w-6 h-6 text-brand-gold" data-id="element-243" />,
    title: 'Calculadora de Probabilidad Implícita',
    description: 'Valor: $47 Para saber si una cuota es un regalo o una trampa.'
  }, {
    icon: <ShieldIcon className="w-6 h-6 text-brand-gold" data-id="element-244" />,
    title: 'Guía de Gestión de Banca',
    description: 'Valor: $197 Cómo dividir tu capital en unidades para que nunca vuelvas a quemar una cuenta.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6 text-brand-gold" data-id="element-245" />,
    title: 'Checklist Pre-Partido',
    description: 'Valor: $27 La lista de verificación que usan los profesionales antes de operar.'
  }, {
    icon: <LanguagesIcon className="w-6 h-6 text-brand-gold" data-id="element-246" />,
    title: 'ENTIENDE APUESTAS (Nomenclatura)',
    description: 'Valor: $97 Domina el lenguaje del mercado y deja de tomar decisiones en un idioma que no hablas.'
  }];
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-247">
      <div className="max-w-5xl mx-auto" data-id="element-248">
        <h2 className="text-3xl md:text-4xl text-center text-brand-text mb-12" data-id="element-249">
          Lo que obtienes hoy:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-250">
          {items.map((item, index) => <div key={index} className={`bg-brand-card border border-brand-gold/10 rounded-xl p-6 flex items-start gap-4 hover:border-brand-gold/30 transition-colors ${index === items.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-251">
              <div className="p-3 bg-brand-bg rounded-lg border border-brand-gold/20 shrink-0" data-id="element-252">
                {item.icon}
              </div>
              <div data-id="element-253">
                <h3 className="text-xl text-brand-text mb-2" data-id="element-254">{item.title}</h3>
                <p className="text-brand-muted" data-id="element-255">{item.description}</p>
              </div>
            </div>)}
        </div>

        {/* Value Breakdown */}
        <div className="mt-12 max-w-2xl mx-auto bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8" data-id="element-256">
          <h3 className="text-2xl md:text-3xl text-center text-brand-gold mb-6 font-bold" data-id="element-257">
            💰 VALOR REAL DEL SISTEMA: $612 USD
          </h3>

          <div className="space-y-3 mb-6" data-id="element-258">
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-259">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-260" />
              <span data-id="element-261">Método Anti-Tipster → $97</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-262">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-263" />
              <span data-id="element-264">Protocolo 5 pasos → $147</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-265">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-266" />
              <span data-id="element-267">Calculadora → $47</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-268">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-269" />
              <span data-id="element-270">Gestión de banca → $197</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-271">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-272" />
              <span data-id="element-273">Checklist → $27</span>
            </div>
            <div className="flex items-center gap-3 text-brand-muted" data-id="element-274">
              <CheckIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-275" />
              <span data-id="element-276">Entiende Apuestas (Nomenclatura) → $97</span>
            </div>
          </div>

          <div className="border-t border-brand-gold/20 pt-6" data-id="element-277">
            <div className="text-center space-y-4" data-id="element-278">
              <p className="text-lg md:text-xl text-brand-muted" data-id="element-279">
                HOY TIENES ACCESO COMPLETO POR:
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-280">
                <span className="text-2xl md:text-3xl text-brand-muted line-through opacity-60" data-id="element-281">
                  $612 USD
                </span>
                <span className="text-5xl md:text-7xl text-brand-gold font-bold animate-pulse" data-id="element-282">
                  $12.99
                </span>
              </div>
              <div className="inline-block bg-brand-gold/20 border-2 border-brand-gold rounded-full px-6 py-2" data-id="element-283">
                <p className="text-xl md:text-2xl text-brand-gold font-bold" data-id="element-284">
                  🔥 98% DE DESCUENTO 🔥
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}